module.exports = __webpack_public_path__ + "img/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.5701646e.webp";